// ==========================
// Version 1 - thirdweb.config.js
// ==========================
export const NFT_COLLECTION_ADDRESS =
  '0x1550e717e7E9aB97eFC09588bECB14b378E29261';

// Later we can add helpers here, e.g.:
// export const ACTIVE_CHAIN = 'polygon-amoy';
// ==========================
// Version 1 - thirdweb.config.js
// ==========================
